import App from '@/models/App'
import ShipSailorInfoSkillHistory from '@/models/ShipSailorInfoSkillHistory'
import ShipSailorInfoBasePeriodHistory from '@/models/ShipSailorInfoBasePeriodHistory'
import ShipSailorInfoContractHistory from '@/models/ShipSailorInfoContractHistory'

export default class ShipSailorInfos extends App {
    static get entity() {
        return 'ShipSailorInfos'
    }
    static get primaryKey() {
        return 'shipSailorId'
    }
    static fields() {
        return {
            shipSailorId: this.attr(''),
            organizationId: this.attr(''),
            userId: this.attr(''),
            skill: this.attr(''),
            basePeriod: this.attr(''),
            startingAt: this.attr(''),
            lastAt: this.attr(''),
            shipOwner: this.attr(''),
            dispatchShipOwner: this.attr(''),
            laborManager: this.attr(''),
            paidHolidays: this.attr(''),
            holidays: this.attr(''),
            workingHours: this.attr(''),
            breakTimeCount: this.attr(''),
            isOvertime: this.attr(''),
            isCompHoliday: this.attr(''),
            isBreakTimeAddition: this.attr(''),
            isBreakTimeReduction: this.attr(''),
            isHolidays: this.attr(''),
            isArticle72: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            resignation: this.attr(null),
            skillHistories: this.hasMany(
                ShipSailorInfoSkillHistory,
                'shipSailorId',
                'shipSailorId'
            ),
            basePeriodHistories: this.hasMany(
                ShipSailorInfoBasePeriodHistory,
                'shipSailorId',
                'shipSailorId'
            ),
            contractHistories: this.hasMany(
                ShipSailorInfoContractHistory,
                'shipSailorId',
                'shipSailorId'
            ),
        }
    }
    static apiConfig = {
        actions: {
            updateSkill(shipId, shipSailorId, params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.patch(
                    `${shipId}/sailors/${shipSailorId}/infos/skill`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            updateBasePeriod(shipId, shipSailorId, params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.patch(
                    `${shipId}/sailors/${shipSailorId}/infos/base/period`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            updateContract(shipId, shipSailorId, params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.patch(
                    `${shipId}/sailors/${shipSailorId}/infos/contract`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            updateResignation(shipId, shipSailorId, params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.patch(
                    `${shipId}/sailors/${shipSailorId}/infos/resignation`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            updateReinstatement(shipId, shipSailorId, params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.patch(
                    `${shipId}/sailors/${shipSailorId}/infos/reinstatement`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
